import React from 'react'
import {Box, Stack} from '@mui/material'
import UpdateIcon from '@mui/icons-material/Update'
import ButtonCustom from '@ui/buttons/buttonCustom/ButtonCustom'
import ActionUiHandler from '@ui/template/actionUiHandler/ActionUiHandler'
import NotItems from '@ui/notItems/NotItems'
import {useConnectedMikrotikQuery} from '@containers/equipment/mikrotik/queryHooks/useConnectedMikrotikQuery'
import {ConnectedMikrotikTable} from '@containers/equipment/mikrotik/ConnectedMikrotikTable'

export const ConnectedMikrotik = () => {
	const {
		data,
		isLoading,
		isFetching,
		refetch,
	} = useConnectedMikrotikQuery()

	return (
		<Box>
			<Stack direction="row" justifyContent="center" mb={2}>
				<ButtonCustom
					startIcon={<UpdateIcon fontSize="small"/>}
					variant="outlined"
					onClick={() => refetch()}
					disabled={isFetching}
				>
					Оновити
				</ButtonCustom>
			</Stack>

			<ActionUiHandler
				isLoading={isFetching}
				isLoadingWithoutRender={isLoading}
			>
				{!data?.length && !isLoading && !isFetching && <NotItems/>}
				<ConnectedMikrotikTable devices={data || []}/>
			</ActionUiHandler>
		</Box>
	)
}

export default ConnectedMikrotik
